import React from "react";
import { Modal } from "../../../../Modal/Default/Index";
import { AlertModal } from "../../../../Modal/Alert/Index";
import { RoundedCloseButton } from "../../../../Buttons/RoundedCloseButton/Index";
import { ButtonOnlyTitle } from "../../../../Buttons/ButtonOnlyTitle/Index";
import { ButtonWithChildren } from "../../../../Buttons/ButtonWithChildren/Index";
import { TitleModal } from "../../../../Modal/Contents/TitleModal/Index";
import { TextModal } from "../../../../Modal/Contents/TextModal/Index";
import { ReactComponent as Check } from "../../../../../assets/svg/icons/CheckFull.svg";
import { ReactComponent as PositiveIcon } from "../../../../../assets/svg/icons/positive.svg";
import { ReactComponent as NegativeIcon } from "../../../../../assets/svg/icons/negative.svg";
import "./styles.css";

interface SuccessModalCreateProductProps {
  visible: boolean;
  onClose: () => void;
  backScreen: () => void;
  newProduct: () => void;
}

interface DeleteModalCreateProductProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const deleteModalContentStyle = {
  width: "600px",
  height: "345px",
  borderRadius: "25px",
} as React.CSSProperties;

export const SuccessModalCreateProduct: React.FC<SuccessModalCreateProductProps> = ({
  visible,
  onClose,
  backScreen,
  newProduct
}) => {
  return (
    <div style={{ zIndex: 910 }}>
      <Modal
        visible={visible}
        contentStyle={{
          padding: "60px",
          width: "600px",
          height: "405px",
          borderRadius: 25,
          position: "relative",
        }}
      >
        <header className="success__modal-header">
          <RoundedCloseButton onClick={() => onClose()} />
        </header>
        <main className="success__modal-main">
          <Check width={40} height={40} />
          <div className="success__modal-message">
            <h2>Concluído!</h2>
            <span>Você cadastrou esse produto com sucesso!</span>
          </div>
        </main>
        <footer className="success__modal-button-container">
          <ButtonOnlyTitle title="Voltar para tela principal" theme="light" onClick={() => backScreen()} />
          <ButtonOnlyTitle title="Cadastrar outro produto" theme="info" onClick={() => newProduct()} />
        </footer>
      </Modal>
    </div>
  );
};

export const DeleteModalCreateProduct: React.FC<DeleteModalCreateProductProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  return (
    <AlertModal visible={visible} contentStyle={deleteModalContentStyle}>
      <section className="formDeleteProduct">
        <div className="close">
          <RoundedCloseButton onClick={onClose} />
        </div>
        <Check width={40} height={40} />

        <div className="infoModal">
          <TitleModal>Você tem certeza?</TitleModal>
          <TextModal>Ao deletar, você perderá esse produto!</TextModal>
        </div>

        <div className="buttons-controll">
          <ButtonWithChildren onClick={onConfirm}>
            <div className="buttonWithChildren--content-inline">
              <PositiveIcon />
              <h6>Sim</h6>
            </div>
          </ButtonWithChildren>
          <ButtonWithChildren onClick={onClose}>
            <div className="buttonWithChildren--content-inline">
              <NegativeIcon />
              <h6>Não</h6>
            </div>
          </ButtonWithChildren>
        </div>
      </section>
    </AlertModal>
  );
};
